import { Dispatch, SetStateAction } from 'react';

export interface RootStateProps<RS> {
  setRootState: Dispatch<SetStateAction<RS>>;
  rootState: RS;
}

export type Gender = 'm' | 'f' | 'no_answer' | 'free' | undefined;

export const isFreeGender = (gender: Gender) => {
  return gender === 'free';
};
